import { Injectable } from '@angular/core';
import { LocalStorage } from '../enums/local-storage-key.enum';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  get(key: LocalStorage): string {
    return localStorage.getItem(key);
  }

  set(key: LocalStorage, value: string) {
    localStorage.setItem(key, value);
  }

  delete(key: LocalStorage) {
    localStorage.removeItem(key);
  }
  
  deleteAll(): void {
    localStorage.clear();
  }

  encryptSpecialCharacter(key: LocalStorage, value: string) {
    const prefix = btoa(unescape(encodeURIComponent(key))).replace(/=/g, '');
    const base64 = btoa(unescape(encodeURIComponent(value)));
    localStorage.setItem(key, btoa(prefix + base64));
  }

  decryptSpecialCharacter(key: LocalStorage) {
    const prefix = btoa(unescape(encodeURIComponent(key))).replace(/=/g, '');
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }
    try {
      const base64 = decodeURIComponent(escape(window.atob(item))).replace(prefix, '');
      return decodeURIComponent(escape(window.atob(base64)));
    } catch (error) {
      return null;
    }
  }
}
